import { useCallback } from "react";
import { useConfigurationDispatch, useConfigurationSelector, } from "../context/ConfigurationReduxContext";
import { removeNavigation } from "../reducers/actions";
import { getCurrentPath } from "../reducers/selectors";
import { useConfigurationNavigationState } from "./useConfigurationNavigationState";
/**
 * Returns of mapping of previous navigation
 *
 * This is intended for returning / scrolling to a substructure instance in the parent configuration object after we navigated to it.
 *
 * @category Hook
 */
export function useConfigurationNavigationMatch(props) {
    const { instancePath } = props;
    const navigationState = useConfigurationNavigationState();
    const currentPath = useConfigurationSelector(getCurrentPath);
    const dispatch = useConfigurationDispatch();
    const targetPath = navigationState[currentPath];
    const isMatch = targetPath === instancePath;
    const remove = useCallback(() => {
        // remove the mapping if it matches
        if (isMatch) {
            dispatch(removeNavigation({ previousPath: currentPath, nextPath: instancePath }));
        }
    }, [currentPath, dispatch, instancePath, isMatch]);
    return [isMatch, remove];
}
//# sourceMappingURL=useConfigurationNavigationMatch.js.map